import { Box, Typography } from "@mui/material";
import ErrorIcon from '@mui/icons-material/Error';
import { SxProps, Theme } from "@mui/material/styles";

interface ErrorAlertProps {
  message: string;
  sx?: SxProps<Theme>;
}

export default function ErrorAlert({ message, sx }: ErrorAlertProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "start",
        gap: 0.5,
        color: "#B83D43",
        py: 1,
        ...sx,
      }}
    >
      <ErrorIcon sx={{ fontSize: "1rem", mt: "0.125rem" }} />
      <Typography variant="body2" fontSize="0.875rem">{message}</Typography>
    </Box>
  );
}
